import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router"
import CustomTable from "../../components/custom-table/CustomTable";
import { piListingData } from "../../utils/tableData";
import {  useSelector } from "react-redux";
import PIApi from "../../services/coordinatingPIService";
import PISubjectApi from "../../services/coordinatingPiSubject";
import ShowAssignedPIPMDrawer from "../../components/custom-drawer/showAssignedPIPMdrawer";
import CustomModel from "../../components/custom-model/CustomModel";
import { updatePhaseValues } from "../../utils/formik/initialValues";
import { updatPhaseValidationSchema } from "../../utils/formik/validationSchema";
import { notify } from "../../bmr/utils/methods/notification";
import HeaderBackNav from "../../components/header-back-navigation/HeaderBackNav";
import CustomSearchbar from "../../components/custom-searchbar/CustomSearchbar";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import NoDataCard from "../../components/no-data-card";
import { Typography } from "@mui/material";
import { PersonSvg } from "../../assets/common-svg/CommonSvg";
import CustomDrawer from "../../components/custom-drawer/CustomDrawer";


const convertPIData = (data) => {
    return data?.map(projectManager => {
        let transformedName = projectManager?.name
        // let transformedPhone = projectManager?.phone
        // let transformedEmail = projectManager?.email
      let phaseList = projectManager?.phaseDetails || [];

const transformedPhase =
  phaseList.length > 1
    ? phaseList.length.toString()
    : phaseList.length === 1
      ? phaseList[0]?.title || "--"
      : "--";

        let transformedPhone = (
  <div>
    <div>{projectManager?.phone || "--"}</div>
    <div style={{ fontSize: "12px", color: "#6b7280" }}>
      {projectManager?.email || "--"}
    </div>
  </div>
);

let transformeditor=projectManager?.editors
        let editorData = [];
    if (projectManager?.editors?.length) {
      editorData = projectManager.editors.map(pi => ({
        id: pi.id,
        name: pi.name,
      }));
    }
    const transformedEditorDisplay = (editorData.length > 1) 
      ? editorData.length.toString() 
      : (editorData.length === 1) 
        ? editorData[0]?.name || "--" 
        : "--";
        let transformedhospitalData = projectManager?.hospital || [];
        const transformedHospitalDisplay =
  transformedhospitalData.length > 1
    ? transformedhospitalData.length.toString()
    : transformedhospitalData.length === 1
    ? transformedhospitalData[0]?.name || "--"
    : "--";
        let transformedPI = projectManager?.id
        return [transformedName,transformedHospitalDisplay, transformedPhone, transformedPhase,transformedEditorDisplay, phaseList, transformedPI,transformeditor,transformedhospitalData];
    });
}

export const PrincipalInvestigatorPage = () => {
    const { loginId, role_slug } = useSelector((state) => state.loginData);
    const isInvestigator = role_slug === 'investigator';
    const [isEditor] = useState(role_slug === 'editor');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    // const [submitLoading, setSubmitLoading] = useState(false);
    const [tableFilters, setTablesFilters] = useState({ searchData: '' })
    const [currentPage, setCurrentpage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [piData, setPiData] = useState(piListingData);
    const [phaseID, setPhaseID] = useState(null)
    const [phaseList, setPhaseList] = useState([]);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [phaseListData, setPhaseListData] = useState([])
    const [initialValues, setInitialValues] = useState(updatePhaseValues);
    const [openModal, setOpenModal] = React.useState(false);
    const [projectManagerResponse, setProjectManagerResponse] = useState([])
    const [rowId, setRowId] = useState(null)
    const [openEditorDrawer, setOpenEditorDrawer] = useState(false);
  const [editorDrawerData, setEditorDrawerData] = useState([]);
  const [editorSearch, setEditorSearch] = useState("");


    const [modelData, setModelData] = useState({
        editTitle: "Update Phase",
        children: [
            {
                type: "multidropdown",
                name: "phase",
                label: "Phase ",
                placeholder: "Select Phase",
                data: phaseList,
                IsRequired: true,
            }
        ],
    });
    const [phaseSearch, setPhaseSearch] = useState("");
    
    const handleNavigateToDetails = React.useCallback((row) => {
        navigate(`assigned-principal-investigator-details/${row[row?.length - 1]}`, {
          state: [
            { name: "Assigned Principal Investigator", path: location.pathname },
            {
              name: "Details",
              path: `${location.pathname}/assigned-principal-investigatorr-details/${row[row?.length - 1]}`,
            },
          ],
        });
    }, []);

    useEffect(() => {
        if (tableFilters?.searchData[tableFilters?.searchData?.length - 1] != " ") {
            setLoading(true)
            getPiProjectManagerListing();
        }
    }, [currentPage, tableFilters, phaseID])

    useEffect(() => {
        getPhase()
    }, [])

    // Updated phase dropdown function to match Subject page
const getPhase = () => {
  let investigator_id = "";
  let user_id = "";
  let editor_id = "";

  if (isInvestigator) {
    investigator_id = loginId;
  } 
  else if (isEditor) {
    editor_id = loginId;
  } 
  else {
    user_id = loginId;
  }

  PISubjectApi.getPhaseDropDown("", investigator_id, user_id, editor_id)
    .then((res) => {
      const data = res?.data?.map((val) => ({
        id: val.id,
        name: `${val.title} (${val?.product_details?.name})`,
      }));
      setPhaseList(data);
    })
    .catch((error) => {
      notify.error(error);
    });
};

    const getPiProjectManagerListing = () => {
        const pm_id = loginId;
        
        PIApi.getPIData(10, currentPage, tableFilters?.searchData, phaseID, pm_id)
            .then((res) => {
                let rowData = convertPIData(res?.data || [])
                setProjectManagerResponse(res?.data)
                setPiData(prev => ({
                    ...prev,
                    rows: [...rowData]
                }));

                setTotalPage(Math.ceil(res?.page_details?.no_of_records / res?.page_details?.limit));
                setCurrentpage(res?.page_details?.page);
                setLoading(false);
            })
            .catch((error) => {
                notify.error(error)
                setLoading(false);
            })
    }

    const handleTableFilters = (e) => {
        setTablesFilters({ ...tableFilters, searchData: e })
        setCurrentpage(1)
    }

    const handlePagination = async (value) => {
        setCurrentpage(value);
    };

    const handleDropDownChange = (e) => {
        setPhaseID(e.target.value)
        setCurrentpage(1)
    }
    
const handleCellClick = (row, columnIndex) => {
    const phaseColumnIndex = 3; // "No. of Phase" column index (0-based)
    const editorColumnIndex = 4; // "Editor" column index (0-based)

    if (columnIndex === phaseColumnIndex) {
      const phaseData = row[5];
      if(phaseData.length > 0){
      setPhaseListData(phaseData);
      setOpenDrawer(true);
      }
    } else if (columnIndex === editorColumnIndex) {
      const editorData = row[7] || [];
      if (editorData.length > 0) {
        setEditorDrawerData(editorData);
        setOpenEditorDrawer(true);
      } else {
        // Optional: notify.info("No Editor assigned");
      }
    }
  };
  const handleAddButton = (row) => {
    setOpenModal(true);
    // PI id is at index 6 in the row array
    setRowId(row[6]);
    const projectManagerData = projectManagerResponse.find((projectManager) => projectManager.id === row[6]);
    setInitialValues({
      phase: projectManagerData?.phaseDetails?.map(item => item.id) || [],
    });
  };
  const filteredPhaseListData = phaseListData.filter(phase =>
    phase?.title?.toLowerCase().includes(phaseSearch.toLowerCase()) ||
    phase?.product_details?.name?.toLowerCase().includes(phaseSearch.toLowerCase())
  );


  const filteredEditorDrawerData = editorDrawerData.filter(editor =>
    (editor.name?.toLowerCase() || "").includes(editorSearch.toLowerCase()) ||
    (editor.role?.toLowerCase() || "").includes(editorSearch.toLowerCase())
  );


    return( <>
        <div className="flex flex-col gap-0 bg-white p-0 !pb-0">
            <CustomModel
                rowId={rowId}
                modalInitialValues={initialValues}
                initialValuesValidationSchema={updatPhaseValidationSchema}
                open={openModal}
                setOpen={setOpenModal}
                setModelData={setModelData}
                modelData={modelData}
                // handleModelValues={handleUpdate}
                // isLoadingBtn={submitLoading}
            />
            <CustomTable
                rows={piData?.rows}
                columnAlign={piData?.columnAlign}
                columns={piData?.columns}
                TableData={piData?.TableData}
                handleNavigate={handleNavigateToDetails}
                loading={loading}
                handleTableFilters={handleTableFilters}
                handleChangePage={handlePagination}
                handleAddButton={handleAddButton}
                handleChangeDropDown={handleDropDownChange}
                dropDownValue={phaseID}
                MenuList={phaseList}
                tableFilters={tableFilters}
                currentPage={currentPage}
                totalpage={totalPage}
                isCloumnClick={true}
                            handleCellClick={(row, columnIndex) => {
    handleCellClick(row, columnIndex);
  }}
            />
        </div>
       {/* Phase List Drawer */}
            <ShowAssignedPIPMDrawer 
              open={openDrawer} 
              toggleDrawer={() => setOpenDrawer(false)}
            >
              <div className="w-[25rem]">
                <div className="pl-4 pt-4 pr-4">
                  <HeaderBackNav
                    handleBackNav={() => setOpenDrawer(false)}
                    TitleFontSize={"18px"}
                    TitleFontWeight={700}
                    Title="Phase List"
                  />
                </div>
                <hr />
                <div className="pl-3 pt-3 pr-3">
                  <CustomSearchbar
                    Placeholder="Search by Phase or Product"
                    BgColor="#dfe0eb"
                    value={phaseSearch}
                    handleSearch={(value) => setPhaseSearch(value)}
                  />
                  <ul className="p-2 cursor-pointer">
                    {loading ? (
                      <SkeletonLoader rowCount={5} height={"35px"} />
                    ) : filteredPhaseListData?.length === 0 ? (
                      <div className="mt-4">
                        <NoDataCard />
                      </div>
                    ) : (
                      filteredPhaseListData?.map((phase, index) => (
                        <li
                          key={phase?.id || index}
                          className="flex gap-3 align-center pt-2 pb-2"
                          style={{ borderBottom: "2px solid #dfe0eb" }}
                        >
                          
                          <div className="self-center">
                            <Typography variant="h6">
                              {phase?.title || "Phase title not available"}
                            </Typography>
                            {phase?.product_details?.name && (
                              <Typography variant="body2" color="textSecondary">
                                Product: {phase.product_details.name}
                              </Typography>
                            )}
                          </div>
                        </li>
                      ))
                    )}
                  </ul>
                </div>
              </div>
            </ShowAssignedPIPMDrawer>
            {/* {editor list drawer} */}
            {openEditorDrawer && (
        <CustomDrawer 
          open={openEditorDrawer} 
          toggleDrawer={() => setOpenEditorDrawer(!openEditorDrawer)}
        >
          <div className="w-[25rem]">
            <div className="pl-4 pt-4 pr-4">
              <HeaderBackNav
                handleBackNav={() => setOpenEditorDrawer(false)}
                TitleFontSize={"18px"}
                TitleFontWeight={700}
                Title="Editor Details"
              />
            </div>
            <hr />
            <div className="pl-3 pt-3 pr-3">
              <CustomSearchbar
                Placeholder="Search by Name or Role"
                BgColor="#dfe0eb"
                value={editorSearch}
                handleSearch={(value) => setEditorSearch(value)}
              />
              <ul className="p-2 cursor-pointer">
                {loading ? (
                  <SkeletonLoader rowCount={1} height={"35px"} />
                ) : filteredEditorDrawerData?.length === 0 ? (
                  <div className="mt-4">
                    <Typography variant="body1" className="text-center text-gray-500">
                      No details available
                    </Typography>
                  </div>
                ) : (
                  filteredEditorDrawerData?.map((editor, index) => (
                    <li
                      key={editor?.id || index}
                      className="flex gap-3 align-center pt-2 pb-2"
                      style={{ borderBottom: "2px solid #dfe0eb" }}
                    >
                      <div className="self-center">
                        <PersonSvg />
                      </div>
                      <div className="self-center">
                        <Typography variant="h6">
                          {editor?.name || "Name not available"}
                        </Typography>
                      </div>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        </CustomDrawer>
      )}
      {/* {Product list drawer} */}
    </>
  );
};

